/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moresettingstitle2Inputs */

const en_moresettingstitle2 = /** @type {(inputs: Moresettingstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More settings`)
};

const de_moresettingstitle2 = /** @type {(inputs: Moresettingstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Einstellungen`)
};

/**
* | output |
* | --- |
* | "More settings" |
*
* @param {Moresettingstitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moresettingstitle2 = /** @type {((inputs?: Moresettingstitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moresettingstitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moresettingstitle2(inputs)
	return de_moresettingstitle2(inputs)
});
export { moresettingstitle2 as "moreSettingsTitle" }